import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastMessage = (type, message) => {
  const toastConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  if (type === 1) {
    // Success toast
    toast.success(message, toastConfig);
  } else {
    // Error toast
    toast.error(message, toastConfig);
  }
};

export default ToastMessage;